<div class="wrapper u-margin-top-20 u-border-radius border-color u-padding-16 tile-color-background u-opacity-1">

  <header class="header">
    <h1 class="title">
      Lactate profile curve configuration
    </h1>
    <h3 class="subtitle">
      Select metrics to highlight on the lactate profile curve
    </h3>
  </header>

  <div class="metric-tiles">
    <form [formGroup]="toggleForm">
      <div *ngFor="let slug of allMetricSlugs()" class="metric-tile" [attr.data-slug]="slug">
        <mat-slide-toggle class="metric-toggle" [formControlName]="slug">
          <div class="metric-name">{{getMetricName(slug)}}</div>
        </mat-slide-toggle>
      </div>
    </form>
  </div>

</div>